module.exports = __webpack_public_path__ + "img/event-4@2x.d05e922b.png";